import { DSOrganizations } from '../../../cimsPage/instances/ds'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const orgs = CreateViewEditSoftRemoveRestore({
  object: 'Organization',
  page: DSOrganizations,
  create: '8FD96E73-6C2D-4142-9823-83017399CB34',
  view: '6E6C586B-D4CA-4009-9421-A06C95E7339D',
  edit: '70657777-4C55-42A4-A959-8FB09BC83336',
  removeRestore: '6C134B6A-B5D3-41AE-9411-4F2E031C2A64',
})

export const CreateDesignSubmittalOrganization = orgs.Create
export const ViewDesignSubmittalOrganization = orgs.View
export const EditDesignSubmittalOrganization = orgs.Edit
export const RemoveRestoreDesignSubmittalOrganization = orgs.RemoveRestore

export type DSOrganizationPermissions =
  | typeof CreateDesignSubmittalOrganization
  | typeof ViewDesignSubmittalOrganization
  | typeof EditDesignSubmittalOrganization
  | typeof RemoveRestoreDesignSubmittalOrganization
